import { addDays, endOfDay, max, startOfDay, startOfWeek } from 'date-fns';

import {
  OfficesQuery_offices as Office,
  Timetable_timetable as Timetable,
} from '@typings/api';

export enum SearchDirection {
  next = 1,
  previous = -1,
}

export enum TimetableView {
  WEEK = 7,
  DAY = 1,
}
export interface OfficeGroup extends Pick<Timetable, 'groups'> {
  office: Office;
  hasReachedEndOfRange?: boolean;
  hasReachedStartOfRange?: boolean;
}

export interface TimeTablesState {
  direction: SearchDirection;
  end: Date;
  hasReachedEndOfRange: boolean;
  hasReachedStartOfRange: boolean;
  isSearching: boolean;
  officeGroups: OfficeGroup[];
  start: Date;
  timetableError?: boolean;
  view: TimetableView;
}

export enum ActionType {
  SEARCH_CANCEL,
  SEARCH_CONTINUE,
  SEARCH_ERROR,
  SEARCH_FINISH,
  SEARCH_RESET,
  SEARCH_START,
  TOGGLE_VIEW,
}

export type ActionPayload =
  | { type: ActionType.TOGGLE_VIEW; payload: { view: TimetableView } }
  | { type: ActionType.SEARCH_CANCEL }
  | { type: ActionType.SEARCH_CONTINUE }
  | { type: ActionType.SEARCH_ERROR }
  | { type: ActionType.SEARCH_FINISH; payload: { officeGroups: OfficeGroup[] } }
  | {
      type: ActionType.SEARCH_RESET;
      payload: { initialState: TimeTablesState };
    }
  | { type: ActionType.SEARCH_START; meta: { direction: SearchDirection } };

export function TimeTableReducer(
  draft: TimeTablesState,
  action: ActionPayload,
) {
  switch (action.type) {
    case ActionType.SEARCH_CANCEL: {
      draft.isSearching = false;

      return draft;
    }
    case ActionType.SEARCH_CONTINUE: {
      draft.start = addDays(draft.start, draft.direction * draft.view);
      draft.end = endOfDay(addDays(draft.start, draft.view - 1));

      return draft;
    }
    case ActionType.SEARCH_ERROR: {
      draft.isSearching = false;
      draft.officeGroups = [];
      draft.timetableError = true;

      return draft;
    }
    case ActionType.SEARCH_FINISH: {
      draft.isSearching = false;
      draft.officeGroups = action.payload.officeGroups ?? [];

      return draft;
    }
    case ActionType.SEARCH_RESET: {
      return action.payload.initialState;
    }
    case ActionType.SEARCH_START: {
      draft.direction = action.meta.direction;
      draft.isSearching = true;
      draft.start = addDays(draft.start, action.meta.direction * draft.view);
      draft.end = endOfDay(addDays(draft.start, draft.view - 1));

      return draft;
    }
    case ActionType.TOGGLE_VIEW: {
      draft.view = action.payload.view;
      draft.direction = SearchDirection.next;
      draft.hasReachedEndOfRange = false;
      draft.hasReachedStartOfRange = true;
      draft.isSearching = true;
      draft.start =
        draft.view === TimetableView.WEEK
          ? startOfWeek(draft.start, {
              weekStartsOn: 1,
            })
          : max([draft.start, startOfDay(new Date())]);
      draft.end = endOfDay(addDays(draft.start, draft.view - 1));

      return draft;
    }
  }
}
